<template>
  <div>
    <!-- 售后管理 -->
    <h3>
      {{ $t('message.afterSalesManagement') }}
    </h3>
    <div class="orderStatistics">
      <!-- 售后数量 -->
      <div class="item">
        <div>
          {{ $t('message.afterSalesQuantity') }}
          <div class="num">{{ orderStatistics.after_sales_count }}</div>
        </div>
      </div>
      <!--售后合计金额  -->
      <div class="item">
        <div>
          {{ $t('message.totalAfterSalesAmount') }}
          <div class="num">{{ orderStatistics.after_sales_amount }} ¥</div>
        </div>
      </div>

    </div>
    <!-- 订单统计 -->
    <h3>
      {{ $t('message.detail') }}
    </h3>
    <div class="table">
      <ol>
        <li class="flex05">NO</li>
        <!-- 售后单号 -->
        <li> {{ $t('message.afterSalesOrderNumber') }}</li>
        <!-- 订单/配送单号 -->
        <li> {{ $t('message.orderDeliveryNumber') }}</li>
        <!-- 提出人 -->
        <li> {{ $t('message.peoplePutForward') }}</li>
        <!-- 确认人 -->
        <li> {{ $t('message.affirmName') }}</li>
        <!-- 状态 -->
        <li> {{ $t('message.status') }}</li>
        <!-- 提出时间 -->
        <li> {{ $t('message.forwardTime') }} <i class="el-icon-sort" :class="{ sort: datas.order_by == 'created_at' }"
            @click="setSort('created_at')"></i>
        </li>
        <!-- 完成时间 -->
        <li> {{ $t('message.completionTime') }} <i class="el-icon-sort"
            :class="{ sort: datas.order_by == 'confirm_at' }" @click="setSort('confirm_at')"></i></li>
        <!-- 售后金额 -->
        <li> {{ $t('message.afterSalesAmount') }}</li>
        <!-- 详细 -->
        <li class="flex05"> {{ $t('message.detail') }}</li>
      </ol>
      <ul v-for="(item, index) in tableData" :key="index">
        <li class="flex05">{{ item.rowNumber }}</li>
        <!-- 售后单号 -->
        <li> {{ item.after_sale_sn }}</li>
        <!-- 订单/配送单号 -->
        <li>
          <router-link :to="'/porderDetail?porder_sn=' + item.porder_sn" target="_blank" class="a-link">
            {{ item.porder_sn }}
          </router-link>
        </li>
        <!-- 提出人 -->
        <li> {{ item.created_by }}</li>
        <!-- 确认人 -->
        <li> {{ item.confirm_by }}</li>
        <!-- 状态 -->
        <li> {{ item.status }}</li>
        <!-- 提出时间 -->
        <li> {{ item.created_at }}</li>
        <!-- 完成时间 -->
        <li> {{ item.confirm_at }}</li>
        <!-- 售后金额 -->
        <li> {{ item.after_sales_amount }}</li>
        <!-- 详细 -->
        <li class="flex05">
          <router-link
            :to="item.is_whole_porder == 1 ? '/wholeOrderAfterSale?after_sale_sn=' + item.after_sale_sn : '/afterSaleOfGoods?after_sale_sn=' + item.after_sale_sn"
            target="_blank" class="a-link">
            {{ $t('message.detail') }}
          </router-link>
        </li>
      </ul>
    </div>
    <!-- 分页 -->
    <div class="paginationContainer">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
        :page-sizes="[10, 20, 50, 100]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      orderStatistics: {},
      user_id: this.$route.query.userID,
      datas: {
        page: 1,
        pageSize: 10,
        user_id: this.$route.query.userID,
        order_by: "",
        sort: '',
      },
      total: 0,
      tableData: [],
    };
  },
  created() {
    this.afterSalesStatistics()
    this.afterSalesList()
  },
  methods: {
    afterSalesStatistics() {
      this.$api.clienteleApi.afterSalesStatistics({ user_id: this.user_id }).then((res) => {
        this.orderStatistics = res.data
      });
    },
    afterSalesList() {
      this.$api.clienteleApi.afterSalesList(this.datas).then((res) => {
        this.tableData = res.data.data
        this.total = res.data.total
      });
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.afterSalesList();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.afterSalesList();
    },
    // 倒序查看
    setSort(type) {
      if (this.datas.order_by == type) {
        this.datas.sort == 'desc' ? this.datas.sort = 'asc' : this.datas.sort = 'desc'
      } else {
        this.datas.order_by = type
        this.datas.sort = 'desc'
      }
      this.afterSalesList()

    },
  }
}
</script>
<style lang='scss' scoped>
h3 {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 24px;
}

.orderStatistics {
  display: flex;
  margin: 24px 0;

  .item {
    flex: 1;
    margin-right: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 24px;
    background-color: #fff;
    text-align: center;
    font-size: 18px;
    border-radius: 5px;

    &:nth-last-child(1) {
      margin: 0;
    }

    .num {
      margin-top: 6px;
      color: #b4272d;
    }
  }
}

.table {
  .flex05 {
    flex: 0.5;
  }

  ol {
    i {
      font-size: 25px;
      margin-left: 10px;
      cursor: pointer;
    }

    .sort {
      color: #b4272d;
    }
  }
}

.paginationContainer {
  text-align: center;
  padding: 24px 0;
}
</style>